<template>
  <div class="share-wrap">
    <div class="tip" v-if="isShare" @click="hideTip">
      <img src="./../../common/imgs/share/tip.png" alt="">
    </div>
    <img class="logo" src="./../../common/imgs/share/share_logo.png" alt="">
    <div class="text">
      <img class="search" src="./../../common/imgs/share/share_search.png" alt="">
    </div>
    <div class="share_box">
      <img class="box" src="./../../common/imgs/share/share_box.png" alt="">
      <img @click="handleShaerClick" class="btn" src="./../../common/imgs/share/share_btn.png" alt="">
    </div>

  </div>
</template>

<script> 
  import { shareLink, shareTitle, shareDesc, shareImg,appId } from 'conf/weChatShare_conf';
  import H5WeChat_init from "@/weChat/h5Share.js"
  import { isWeChatBrowser } from "@/utils/appShare.js"
  export default {
    name:"share",
    data(){
      return {
        isShare:false,
      }
    },
    created(){
      H5WeChat_init();
    },
    methods:{
      hideTip(){
        this.isShare = false;
      },
      handleShaerClick(){
        // if(isWeChatBrowser()){
        //   H5WeChat_init();
        //   this.isShare = true;
        // }else{
        //   this.share();
        // }
        this.$router.push('/luck')        
      },
      startAnimation() {},
      checkDevice() {
        // js判断是否是苹果设备
        function checkIsAppleDevice() {
          var u = navigator.userAgent;
          var app = navigator.appVersion;
          var ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          var iPad = u.indexOf("iPad") > -1;
          var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
          if (ios || iPad || iPhone) {
            return true;
          } else {
            return false;
          }
        }
        //js判断是否为Android设备
        if (checkIsAppleDevice()) {
          return "IOS";
        } else {
          return "Android";
        }
      },
      h5Share(){
        this.isShare = true;
        clearTimeout();
        setTimeout(()=>{
          this.$router.push('/luck')
        },5000)
      },
      share(){
        var xPhone = this.checkDevice();//全局手机类型
        if("IOS" == xPhone){
          //ios大象新闻app环境
          if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.requestShareUrl){            
            window.webkit.messageHandlers.requestShareUrl.postMessage({
              'title': shareTitle,
              'summary': shareDesc,
              'shareUrl':shareLink,
              'image':shareImg
            });
            console.log(111111)
            clearTimeout();
            setTimeout(()=>{
              this.$router.push('/luck')
            },3000)
          }else{
            this.h5Share();
          }
        }else{
          //Android大象新闻app环境
          if(window.Android && window.Android.requestShareUrl){
            console.log(2)
            clearTimeout();
            setTimeout(()=>{
              this.$router.push('/luck')
            },3000)
            window.sessionStorage.setItem("isShare",1)
              window.Android.requestShareUrl(
                JSON.stringify({
                  'title': shareTitle,
                  'summary': shareDesc,
                  'shareUrl':shareLink,
                  'image':shareImg
                })
              );
          }else{
            this.h5Share();
          }
          return true;
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.share-wrap {
  position: relative;
  width: 100%;
  height: 932px;
  background: url('./../../common/imgs/share/share_bg.png') no-repeat;
  background-size: 100% 100%;
  .tip{
    width:100%;
    height:100vh;
    position: absolute;
    top:0;
    left:0;
    z-index:998;
    background: rgba(0,0,0,0.5);
    img{
      width:100%;
    }
  }
  .logo {
    display: block;
    width: 192px;
    height: 53px;
    margin: 0 auto;
    padding: 60px 0;
  }
  .text {
    position: relative;
    display: block;
    width: 724px;
    height: 524px;
    background: url('./../../common/imgs/share/share_text.png') no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    .search {
      position: absolute;
      top: 210px;
      left: 200px;
      width: 346px;
      height: 368px;
    }
  }
  .share_box {
    position: relative;
    .box {
      position: absolute;
      right: 0;
      top: 120px; 
      width: 724px;
      height: 485px;
    }
    .btn {
      position: absolute;
      width: 258px;
      height: 258px;
      top:275px;
      left: 150px;
      z-index: 99;
    }
  }
}
</style>